<div class="version-warning-text select-none cursor-pointer" *ngIf="isWrongVersion" (click)="reload()">
  A new version of LoHi is available. Please refresh to get the latest version of the app.
</div>
